import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import React from "react";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function Dropdown({
  children,
  className,
  iconClass,
  menuClass,
  icon,
  options,
  direction = "down" || "up" || "up-right" || "right" || "left" || "center",
  id,
}) {
  const { t } = useTranslation();
  return (
    <Menu as="div" className={`${className} relative inline-block`}>
      <Menu.Button
        className={`${
          iconClass
            ? iconClass
            : "size-11 bg-secondary-30 hover:bg-secondary-80 text-black hover:border"
        } flex items-center justify-center rounded-full text-sm font-semibold transition-all duration-300`}
      >
        {children || icon}
      </Menu.Button>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          className={`absolute z-30 py-1 min-w-32 origin-top-right rounded-xl bg-white shadow-lg focus:outline-none overflow-hidden group menu-position ${menuClass}
                ${
                  direction === "up"
                    ? "bottom-8 left-0"
                    : direction === "up-right"
                    ? "bottom-8 right-0"
                    : direction === "bottom-right"
                    ? "top-2 right-8"
                    : direction === "right"
                    ? "right-0"
                    : direction === "down"
                    ? ""
                    : direction === "left"
                    ? "left-0"
                    : "left-1/2 -translate-x-1/2"
                }`}
        >
          {options?.map((item, index) => (
            <Menu.Item key={index}>
              {({ active }) =>
                item.href ? (
                  <a
                    href={item.href}
                    className={`${classNames(
                      active ? "bg-secondary-3" : "",
                      "flex items-center gap-2.5 pl-3 pr-5 py-2 text-sm cursor-pointer whitespace-nowrap focus:outline-none hover:bg-gray-100",
                      item.value === t("Delete") || item.value === t("Sign out")
                        ? "text-danger hover:!bg-danger-light/30"
                        : "hover:text-primary text-secondary"
                    )} ${item.className}`}
                  >
                    {item.icon && (
                      <div className="flex-shrink-0 w-4.5 flex items-center justify-center">
                        {item.icon}
                      </div>
                    )}
                    {item.value}
                  </a>
                ) : (
                  <div
                    className={`${classNames(
                      active ? "bg-secondary-3" : "",
                      "flex items-center gap-2.5 pl-3 pr-5 py-2 text-sm cursor-pointer whitespace-nowrap focus:outline-none hover:bg-gray-100",
                      item.value === t("Delete") || item.value === t("Sign out")
                        ? "text-danger hover:!bg-danger-light/30"
                        : "hover:text-primary text-secondary"
                    )} ${item.className}`}
                    onClick={item.onClick ? item.onClick : () => item.action(id)}
                  >
                    {item.icon && (
                      <div className="flex-shrink-0 w-4.5 flex items-center justify-center">
                        {item.icon}
                      </div>
                    )}
                    {item.value}
                  </div>
                )
              }
            </Menu.Item>
          ))}
        </Menu.Items>
      </Transition>
    </Menu>
  );
}

export default Dropdown;
